import React, {PureComponent} from 'react';

import { Classes, Overlay, Collapse, Button, MenuItem } from "@blueprintjs/core";
import {Select} from "@blueprintjs/select";

import InputRegular from '../common/InputRegular';

// import {Elements} from '@stripe/react-stripe-js';
// import {loadStripe} from '@stripe/stripe-js';
import CardWithDetailsSetupForm from '../views/addFunds/CardWithDetailsSetupForm';

// const stripePromise = loadStripe("pk_test_TYooMQauvdEDq54NiTphI7jx");
// const stripePromise = loadStripe("pk_test_51Hdu33K5UACAN2bBNUfTCIBswEZi0b5GynCL1zgdwEvQ0lLuANUJ3NQCYh3Blo6SX8flCQDayhD8bpmtITbcC8rq00uqS7k0G5"); /*Golubov*/
// const stripePromise = loadStripe(process.env.REACT_APP_STRIPE);

export default class AddPaymentMethodModal extends PureComponent{
    state={
        overlayIsOpen: false,
        billingDetailsOpen: true,
    }
    handleClose = () => {
        this.setState({
            overlayIsOpen: false
        })
    }
    componentDidMount(){
        this.setState({
            overlayIsOpen: this.props.showModal,
        })
    }
    componentDidUpdate(){
        if (this.state.overlayIsOpen !== this.props.showModal){
            this.setState({
                overlayIsOpen: this.props.showModal
            })
        }
        if (!this.props.showModal && this.state.billingDetailsOpen){
            this.setState({billingDetailsOpen: true})
        }
    }

    // setTestNumber = (e) => {
    //     this.setState({testNumber: e.target.value})
    // }

    render(){
        // const inputProps = {
        //     placeholder: '063 1234567',
        // };
        //
        // const intlTelOpts = {
        //     preferredCountries: [],
        // };
        // const onReady = (instance, IntlTelInput) => console.log(instance, IntlTelInput);
        return(
            <Overlay
                // onClose={this.props.handleClose}
                className={this.state.billingDetailsOpen ? (Classes.OVERLAY_SCROLL_CONTAINER + ' padding-top-400 z-index-20') : (Classes.OVERLAY_SCROLL_CONTAINER + ' padding-top-400 z-index-20')}
                // isOpen={this.state.overlayIsOpen}
                isOpen={this.props.showModal}
            >
                <div className="modal-field-payment" style={{width: this.props.width || '60%', maxWidth: this.props.maxWidth || '100%'}}>
                    <div className="add-payment-method-modal-container">
                        <div className='modal-title'>
                            <p className="modal-close-button" onClick={ this.props.handleClose }><i className="fas fa-times"></i></p>
                            <h2>Add New Payment Method</h2>
                        </div>

                        <div className='modal-main'>
                            <h3>Payment Details</h3>
                            <div className='credit-cards-images-container'>
                                <img src='/img/cards/payment-methods/master-card.png'/>
                                <img src='/img/cards/payment-methods/visa.png'/>
                                <img src='/img/cards/payment-methods/discover.png'/>
                                <img src='/img/cards/payment-methods/amex.png'/>
                            </div>
                            {/*<Elements stripe={stripePromise}>*/}
                            <CardWithDetailsSetupForm
                                handleClose={ this.props.handleClose }
                                user={this.props.user}
                                stripePlanId={this.props.stripePlanId}
                                updatePaymentMethods={ this.props.updatePaymentMethods }
                                // subscribeToPlan={this.props.subscribeToPlan}
                                newProject={ this.props.newProject }
                                newPaymentMethodForProject={this.props.newPaymentMethodForProject}
                                updateUserFromServer={this.props.updateUserFromServer}
                                errorMessage={this.props.errorMessage}
                                project={this.props.project}
                                proPlanSuccessModalActive={this.props.proPlanSuccessModalActive}
                                passBillingDetailsOpen={a => this.setState({billingDetailsOpen: a})}
                                dataFromNavigation={this.props.dataFromNavigation}
                                updateWithDataFromNavigation={()=>this.props.updateWithDataFromNavigation(this.props.dataFromNavigation)}
                                payPhoneNumbers={this.props.payPhoneNumbers}
                                selectedSource={this.props.selectedSource}
                                paymentMethods={this.props.paymentMethods}
                            />
                            {/*</Elements>*/}
                        </div>
                    </div>

                </div>
            </Overlay>
        )
    }
}